module.exports = __webpack_public_path__ + "a17d279f/img/copy-icon.408fdb2d.svg";